import script from "./RecommendTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendTag.vue?vue&type=script&setup=true&lang=ts"

import "./RecommendTag.vue?vue&type=style&index=0&id=ef1ea918&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef1ea918"]])

export default __exports__